export default __webpack_public_path__ + "static/media/008-salad.9ed18804.svg";